// extracted by mini-css-extract-plugin
module.exports = {"sticker":"Sticker_sticker__X5MCb","sticker__after":"Sticker_sticker__after__ztvKB"};